// lib/list/factoryReferenceLookup.ts
/** Only read-only Factory discovery and its planning note may continue into a requested mutation. */
import type { ScriptInstance } from '#types/types';
const lookupActions = ['LIST_FACTORY_FOLDERS', 'LIST_FACTORY_REFERENCE_IMAGES', 'SHOW_FACTORY_REFERENCES', 'OPEN_FACTORY_REFERENCE', 'LIST_FACTORY_PERSONAS', 'LIST_FACTORY_OBJECTS'];
export const isFactoryReferenceLookupScript = (commands: readonly { action_type?: unknown }[]): boolean => (
  commands.some(command => lookupActions.includes(String(command.action_type)))
  && commands.every(command => lookupActions.includes(String(command.action_type)) || command.action_type === 'SET_PLAN')
);

export const requiresListScriptPersistence = (script: Pick<ScriptInstance, 'commands' | 'listCreativePlan' | 'listReferenceContinuation'>) =>
  Boolean(script.listCreativePlan || script.listReferenceContinuation || isListContextPreparationScript(script.commands));

export const isListContextPreparationScript = (commands: readonly { action_type?: unknown }[]): boolean => (
  isFactoryReferenceLookupScript(commands) || (commands.some(command => command.action_type === 'MANAGE_LIST_CONTEXT')
    && commands.every(command => [...lookupActions, 'MANAGE_LIST_CONTEXT', 'SET_PLAN'].includes(String(command.action_type))))
);

/** Saving a persona may continue so a "create it and build its panel" request finishes in one exchange. */
export const isFactoryPersonaSetupScript = (commands: readonly { action_type?: unknown }[]): boolean => (
  commands.some(command => command.action_type === 'MANAGE_FACTORY_PERSONA')
  && commands.every(command => ['MANAGE_FACTORY_PERSONA', 'LIST_FACTORY_PERSONAS', 'SET_PLAN'].includes(String(command.action_type)))
);
